import { ValidatorComponent } from 'react-form-validator-core';
import { VALIDATORS } from '@/constants/validators';

class FieldValidator extends ValidatorComponent {
  constructor(props) {
    super(props);

    const { validators, label } = props;
    this.customLabel = label;

    if (label && validators) {
      if (validators.includes(VALIDATORS.IS_REQUIRED)) {
        this.customLabel = label + '*';
      }
    }
  }

  errorText() {
    return this.state.isValid ? null : (
      <div className="invalid-feedback" data-test-id="invalid-feedback">
        {this.getErrorMessage()}
      </div>
    );
  }

  renderValidatorComponent() {
    throw new Error('renderValidatorComponent must be implemented');
  }
}

FieldValidator.defaultProps = {
  ...ValidatorComponent.defaultProps,
  withRequiredValidator: true
};

export default FieldValidator;
